import React from 'react';

interface DaiProps {
    width: number;
}

const Dai: React.FC<DaiProps> = ({ width }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 94 95"
        width={width}
        style={{ verticalAlign: 'middle' }}
    >
        <g fill="none">
            <circle cx="47" cy="47.25" r="47" fill="#F9FAFB" />
            <path
                fill="#F6A303"
                d="M47 94.25c25.957 0 47-21.043 47-47s-21.043-47-47-47-47 21.043-47 47 21.043 47 47 47z"
            />
            <path
                fill="#FFF"
                d="M73.871 39.495h-5.577c-3.071-8.523-11.327-14.366-22.216-14.366H28.171v14.366h-6.22v5.154h6.22v5.405h-6.22v5.155h6.22v14.194h17.907c10.763 0 18.957-5.797 22.106-14.194h5.687v-5.155h-4.434c.11-.908.173-1.848.173-2.788v-.126c0-.846-.047-1.676-.126-2.49h4.403v-5.155h-.016zm-40.686-9.776h12.893c7.99 0 13.928 3.932 16.67 9.76H33.185v-9.76zm12.893 35.046H33.185v-9.572h29.531c-2.757 5.734-8.679 9.572-16.638 9.572zm18.346-17.39c0 .909-.063 1.802-.188 2.664H33.185v-5.405h31.067c.11.846.172 1.723.172 2.616v.125z"
            />
        </g>
    </svg>
);

export default Dai;
